"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MESSAGES_COPY = void 0;
const GENERIC_1 = require("../../../copy/GENERIC.js");
exports.MESSAGES_COPY = {
    ARE_YOU_SURE: 'Are you sure?',
    ARE_YOU_SURE_INTEGRATION_APP: 
    // eslint-disable-next-line max-len
    'Are you sure you want to hide this app? Don\'t worry, if we see another API call from this application it will reappear.',
    ARE_YOU_SURE_STAKEHOLDER: 
    // eslint-disable-next-line max-len
    'Are you sure you want to delete this stakeholder? This action is permanent, and all stakeholder information will be deleted.',
    BULK_ADD_INITIATIVES_LIMIT: 'Only 1000 entities can be added to an initiative at a time. Please unselect some and try again.',
    BULK_ADD_LIMIT: 'Only 1000 entities can be added at a time.',
    HIDE_AS_WELL_INTEGRATION_APP: 'Do you want to hide this application as well?',
    INVALID_FILE_NAME: 'The file name must be 64 characters or less',
    INVALID_LINK_TITLE: 'The link title must be 64 characters or less',
    INVALID_OIDC_CLIENT_ID: 'The client ID contains invalid characters',
    INVALID_OIDC_DOMAIN: 'Please enter a valid URL',
    INVALID_SALESFORCE_ACCOUNT_ID: 'The Salesforce Account ID can only contain alphanumeric characters and have a length of 18 characters',
    INVALID_SUBDOMAIN: 'The name of this subdomain contains invalid characters',
    MAX_LENGTH_EXCEEDED: 'Max length exceeded',
    PASSWORDS_DO_NOT_MATCH: 'Passwords do not match',
    PLEASE_CONFIRM_PASSWORD: 'Please confirm password',
    PLEASE_ENTER_A_STAKEHOLDER_NAME: 'Please enter a stakeholder name',
    PLEASE_ENTER_CURRENT_PASSWORD: 'Please enter your current password',
    PLEASE_ENTER_EMAIL: 'Please enter a valid email',
    PLEASE_ENTER_INITIATIVE_NAME: 'Please enter an initiative name',
    PLEASE_ENTER_NEW_PASSWORD: GENERIC_1.COPY_GENERIC.PASSWORD_MESSAGE('new password'),
    PLEASE_ENTER_PASSWORD: GENERIC_1.COPY_GENERIC.PASSWORD_MESSAGE('password'),
    PLEASE_ENTER_TASK_NAME: 'Please enter a task name',
    PLEASE_ENTER_URL: 'Please enter a valid URL',
    PLEASE_ENTER_YOUR_COMPANY_NAME: 'Please enter your company name',
    PLEASE_ENTER_YOUR_FIRST_NAME: 'Please enter your first name',
    PLEASE_ENTER_YOUR_LAST_NAME: 'Please enter your last name',
    PLEASE_ENTER_YOUR_TEAM_MEMBERS_EMAIL: 'Please enter your team member\'s email',
    PLEASE_ENTER_YOUR_TEAM_MEMBERS_FIRST_NAME: 'Please enter your team member\'s first name',
    PLEASE_ENTER_YOUR_TEAM_MEMBERS_LAST_NAME: 'Please enter your team member\'s last name',
    PLEASE_SELECT_DIFFERENT_ORGANIZATION: 'Please select a different organization',
    THIS_INITIATIVE_HAS_NO_SCOPE: 
    // eslint-disable-next-line max-len
    'This initiative doesn\'t have any scope. Visit any	Salesforce object card and add it as scope to this initiative.',
    YOUR_INITIATIVE_NAME_WILL_BE_LOST: 'Your initiative name will be lost. Continue?'
};
//# sourceMappingURL=COPY.js.map